const colors = {
  cardBg: '#ffffff',
  navy: '#071a52',
  greenDark: '#5cb83c',
  textPrimary: '#1a1a2e',
  textSecondary: '#6b7280',
  border: '#e2e4e8',
};

function PartCard({ lot }) {
  const pno = lot.item?.no || '';
  const pname = lot.item?.name || 'Unknown';
  const colorId = lot.color_id || 0;
  const colorName = lot.color_name || '';
  const qty = lot.quantity || 0;
  const price = lot.unit_price || '0.00';
  const cond = lot.new_or_used === 'N' ? 'New' : 'Used';
  const isLow = qty > 0 && qty <= 2;

  return (
    <div style={{
      background: colors.cardBg,
      border: `1px solid ${isLow ? '#fed7aa' : colors.border}`,
      borderRadius: '6px',
      padding: '12px 10px',
      textAlign: 'center',
      transition: 'transform 0.12s ease, box-shadow 0.12s ease',
      cursor: 'pointer',
    }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={{ position: 'relative', marginBottom: '8px' }}>
        <img
          src={(lot.remarks || '').toUpperCase().startsWith('MF')
            ? `https://img.bricklink.com/ItemImage/MN/0/${pno}.png`
            : `https://img.bricklink.com/ItemImage/PN/${colorId}/${pno}.png`}
          alt={pname}
          style={{
            width: '100%',
            maxHeight: '100px',
            objectFit: 'contain',
          }}
          onError={(e) => { e.target.style.opacity = '0.15'; }}
        />
        <span style={{
          position: 'absolute',
          top: '2px',
          left: '4px',
          fontSize: '1.2rem',
          fontWeight: 800,
          color: isLow ? '#d97706' : colors.navy,
          lineHeight: 1,
        }}>{qty}</span>
      </div>

      <div
        onClick={(e) => {
          e.stopPropagation();
          const type = (lot.remarks || '').toUpperCase().startsWith('MF') ? 'M' : (lot.item?.type || 'P');
          const typeMap = { P: 'P', PART: 'P', M: 'M', MINIFIG: 'M', S: 'S', SET: 'S', G: 'G', GEAR: 'G' };
          const blType = typeMap[type] || 'P';
          window.open(`https://www.bricklink.com/v2/catalog/catalogitem.page?${blType}=${pno}`, '_blank');
        }}
        style={{
          fontSize: '0.78rem',
          fontWeight: 800,
          color: colors.navy,
          marginBottom: '3px',
          textDecoration: 'underline',
          textDecorationColor: 'rgba(7,26,82,0.3)',
          textUnderlineOffset: '2px',
          cursor: 'pointer',
        }}
      >{pno}</div>

      <div style={{
        fontSize: '0.66rem',
        color: colors.textSecondary,
        marginBottom: '2px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}>{pname}</div>

      <div style={{
        fontSize: '0.66rem',
        color: colors.textSecondary,
      }}>{colorName}</div>

      <div style={{
        fontSize: '0.66rem',
        color: colors.textSecondary,
      }}>${price}</div>

      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '4px',
        padding: '2px 8px',
        fontSize: '0.58rem',
        marginTop: '6px',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        fontWeight: 700,
        background: isLow ? '#fff7ed' : cond === 'New' ? '#f0f9ff' : '#fffbeb',
        color: isLow ? '#d97706' : cond === 'New' ? colors.navy : '#b45309',
        border: `1px solid ${isLow ? '#fed7aa' : cond === 'New' ? '#bfdbfe' : '#fde68a'}`,
      }}>
        {isLow ? `Low (${qty})` : cond}
      </span>
    </div>
  );
}

export default PartCard;